import { TournamentShortDto } from '@features/landing/grandprix/typings';

type Props = {
  tournament: Pick<TournamentShortDto, 'clockControlSettings'>;
};

export function ClockControl({ tournament }: Props) {
  if (!tournament.clockControlSettings) {
    return null;
  }

  const initialMinutes = tournament.clockControlSettings.initialSeconds / 60;
  const addSecondsPerMove = tournament.clockControlSettings.addSecondsPerMove;

  return (
    <>
      {initialMinutes}&apos; + {addSecondsPerMove}&apos;&apos;
    </>
  );
}
